import * as yup from 'yup';

const initialValues = {
  addressType: '',
  addrLn1: '',
  addrLn2: '',
  addrLn3: '',
  country: '',
  telephoneNo: '',
  mobileNo: '',
  emergencyConPerson: '',
  emergencyConNo: '',
};

const validationSchema = yup.object().shape({
  addressType: yup.string().trim().required('Address Type is required'),
  addrLn1: yup.string().trim().required('Address Line 1 is required'),
  addrLn2: yup.string().trim(),
  addrLn3: yup.string().trim(),
  country: yup.string().trim().required('Country is required'),
  telephoneNo: yup
    .string()
    .matches(/^[0-9]+$/, 'Telephone No. must be a number')
    .required('Telephone No. is required'),
  mobileNo: yup
    .string()
    .matches(/^[0-9]+$/, 'Mobile No. must be a number')
    .required('Mobile No. is required'),
  emergencyConPerson: yup
    .string()
    .trim()
    .required('Emergency Contact Person is required'),
  emergencyConNo: yup
    .string()
    .matches(/^[0-9]+$/, 'Emergency Contact No. must be a number')
    .required('Emergency Contact No. is required'),
});

const transformLocalAddressData = apiData => ({
  addressType: 'LOCAL_ADDRESS',
  addrLn1: apiData.LocalAddrLn1 || '',
  addrLn2: apiData.LocalAddrLn2 || '',
  addrLn3: apiData.LocalAddrLn3 || '',
  country: apiData.LocalCountry || '',
  telephoneNo: apiData.LocalTelephone || '',
  mobileNo: apiData.LocalMobile || '',
  emergencyConPerson: apiData.EmergencyConPerson || '',
  emergencyConNo: apiData.EmergencyConNo || '',
});

const transformPermAddressData = apiData => ({
  addressType: 'PERM_ADDRESS',
  addrLn1: apiData.PermAddrLn1 || '',
  addrLn2: apiData.PermAddrLn2 || '',
  addrLn3: apiData.PermAddrLn3 || '',
  country: apiData.PermCountry || '',
  telephoneNo: apiData.PermTelephone || '',
  mobileNo: apiData.PermMobile || '',
  emergencyConPerson: apiData.EmergencyConPerson || '',
  emergencyConNo: apiData.EmergencyConNo || '',
});

export {
  initialValues,
  validationSchema,
  transformLocalAddressData,
  transformPermAddressData,
};
